<template>
<div class="q-pa-md">
    <div class="container q-pa-xl">

        <div class="row  myhead">
        <div class="col">
            <span class="head1">uniQin Help and Support</span>
            <p style="margin:0">Send us your query and we will get back to you</p>
        </div>
        
        </div>

        <div class="row mybody">
           
            <div class="row col-12">
                <div class="col-6">
            
                    <label><span style="color:#ff0000">*</span> Choose Category</label>
                    <p>Select the issue on which you want our support</p> 
                </div>
                <div class="col-6">
                    <select id="mySelect" v-model="issue_data[0]['incident_type']">
                        <option value="Enquiry">Enquiry</option>
                        <option value="Help Needed ">Help Needed</option>
                        <option value="Suggestion">Suggestion</option>
                        <option value="Report Application Crash">Report Application Crash</option>
                        <option value="Wrong Data">Wrong Data</option>
                        <option value="Others">Others</option>
                    </select>
                </div>
            </div> 

            <div class="row col-12">
                <div class="col-6">
            
                    <label><span style="color:#ff0000">*</span> Description</label>
                    <p>Brief description on the topic</p> 
                </div>
                <div class="col-6">
                    <textarea  id="text_area" rows="5" cols="39" placeholder="Write your problem here">
                    </textarea>
                </div>
            </div> 

            <div class="row col-12" style="margin:20px 0">
                <div class="col-6">
            
                    <p>Attach any file or screenshot of the issue</p> 
                </div>
                <div class="col-6" >
                    <input type="file" accept="image/*" id="fileInput" ref="file" @change="img_set = true"/>
                </div>
            </div>

            <div class="row col-12 justify-between">
                <div class="col-6">

                    <p><span style="color:#ff0000">*</span> Marked fields are mandatory</p> 
                </div>

                <div class="row col-4">
                    <div class="col-6">
                      <q-btn color="secondary" label="submit" @click="send_data()"></q-btn>
                    </div>
                    <div class="col-6">
                    <q-btn color="deep-orange" label="cancel" @click="cancel_data()"></q-btn>
                    </div>
                </div>
            </div> 
       
        </div>

        
        <div class="q-pa-md">
            <div class="row col-12" style="margin:20px 0">
                <div class="col-6">
                    <label>Status of your old incidents</label>
                    <p>Past incident status will be shown here</p>  
                    
                </div>
                <div class="col-6" >
                    <div class="row">
                        <div class="col-6 align">
                            
                            <input type="radio" name="show_all" @click="showAll()"> 
                            <label style="font-weight:400" for="show_all">Show all</label>
                        </div>
                        <div class="row col-12">
                            <div class="col-5 align">
                                <input type="radio" name="show_all" @click="Show()"> 
                                <label style="font-weight:400" for="show_all">Show incident</label>
                            </div>
                            <div class="col-7 align" style="width:58%">
                                <input type="text" v-model="incident_no" placeholder="Enter Incident Number here" />
                            </div>
                        </div>
                        <div class="row justify-center col-4" style="margin-top:20px">
                            <q-btn color="secondary" label="show" @click="show?Show():show_btn=true; show_btn=true"></q-btn>
                        </div>
                        
                    </div>
                    
                </div>
            </div>

        </div>

        <div class="row show">
            <div v-if="show && show_btn">
                <q-table
                  :loading="isLoading"
                   ref="table"
                   class="my-sticky-virtscroll-table"
                   virtual-scroll
                   disable-pagination
                  style="background-color:white;width:900px"
                  :data="rows1"
                                  
                  hide-bottom
                  
                  :columns="columns"
         
                >

                <template v-slot:header="props">
                  <q-tr :props="props">
                    
                    <q-th
                      v-for="col in columns"
                      :key="col.name"
                      :props="props"
                      class="headerText"
                      :style="{ fontSize: '15px', color: 'black' }"
                      style="background-color:#61b5d9;"
                    >
                      {{ col.label }}
                    </q-th>
                  </q-tr>
                </template>

                <template v-slot:body="props">
                  
            
                  <q-tr
                   
                    :props="props"
                    style="background-color:white"
                  >
                    <q-td key="incident_no" :props="props">
                      {{ props.row['incident_no'] }}
                    </q-td>

                    <q-td key="subject" :props="props">
                      {{
                        props.row['subject']
                      }}
                    </q-td>
                    <!--
                    <q-td key="description" :props="props">
                      {{ props.row['description'] }}
                    </q-td>
                    -->
                    <q-td key="date_of_create" :props="props">
                      {{
                        props.row['date_of_create']
                      }}
                    </q-td>
                    <q-td key="present_status" :props="props">
                      {{ props.row['present_status'] }}
                    </q-td>

                    <q-td key="date_of_last_update" :props="props">
                      {{
                        props.row['date_of_last_update']
                      }}
                    </q-td>
                    
                    
                  </q-tr>
                </template>
                
                </q-table>

            </div>

            <div v-if="show_all && show_btn">
                <q-table
                  :loading="isLoading"
                   ref="table"
                   class="my-sticky-virtscroll-table"
                   virtual-scroll
                   disable-pagination
                  style="background-color:white;width:900px"
                  :data="rows1"
                                  
                  hide-bottom
                  
                  :columns="columns"
         
                >

                <template v-slot:header="props">
                  <q-tr :props="props">
                    
                    <q-th
                      v-for="col in columns"
                      :key="col.name"
                      :props="props"
                      class="headerText"
                      :style="{ fontSize: '15px', color: 'black' }"
                      style="background-color:#61b5d9;"
                    >
                      {{ col.label }}
                    </q-th>
                  </q-tr>
                </template>

                <template v-slot:body="props">
                  
            
                  <q-tr
                    v-for="row in rows"
                    :props="props"
                    style="background-color:white"
                    v-bind:key="row.incident_id"
                  >
                    <q-td key="incident_no" :props="props">
                      {{ row['incident_id'] }}
                    </q-td>

                    <q-td key="subject" :props="props">
                      {{
                        row['incident_type']
                      }}
                    </q-td>
                    <!--
                    <q-td key="description" :props="props">
                      {{ row['description'] }}
                    </q-td>
                    -->
                    <q-td key="date_of_create" :props="props">
                      {{
                        row['datetime_of_create']
                      }}
                    </q-td>
                    <q-td key="present_status" :props="props">
                      {{ row['status'] }}
                    </q-td>

                    <q-td key="date_of_last_update" :props="props">
                      {{
                        row['datetime_of_last_update']
                      }}
                    </q-td>
                    
                    
                  </q-tr>
                </template>
                
                </q-table>

            </div>



        </div>
        
    </div>

    
</div>
</template>

<script>
import { generateUploadURL } from './s3.js';

export default {

    data() {
        return{
        api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
        user_id:'',
        time_stamp:'',
        img_set:false,
        file:'',
        show_all: false,
        show: false,
        show_btn:false,
        incident_no: '',
        file_name:'',
        issue_data : [{
                    'user_id':'',
                    'datetime_of_create':'',
                    'datetime_of_last_update':'',
                    'phone_no':'',
                    'incident_type':'Enquiry',
                    'description': '',
                    'status':'New',
                    'severity':'',
                    'uploaded_file_path_in_s3':''
                    }],
        columns: [
        {
          name: "incident_no",
          required: true,
          label: "Incident No",
          align: "center",
          field: "incident_no",
        },
        {
          name: "subject",
          required: true,
          label: "Subject",
          align: "center",
          field: "subject",
        },
        /*
        {
          name: "description",
          required: true,
          label: "Description",
          align: "center",
          field: "description",
        },*/
        {
          name: "date_of_create",
          required: true,
          label: "Date of creating the issue",
          align: "center",
          field: "date_of_create",
        },
        {
          name: "present_status",
          required: true,
          label: "Present Status",
          align: "center",
          field: "present_status",
        },
        {
          name: "date_of_last_update",
          required: true,
          label: "Date of last update",
          align: "center",
          field: "date_of_last_update",
        },
        
        ],

        rows:'',
        rows1:[{
            incident_no:'',
            subject:'',
            description:'',
            date_of_create:'',
            present_status:'',
            date_of_last_update:''
        }],

        }
       
        
    },

    methods: {
        async send_data(){
            this.$q.loading.show({
              message: "Submitting your query, please wait..",
            });
            



            if(this.issue_data[0].incident_type === 'Enquiry' || this.issue_data[0].incident_type === 'Suggestion')
            {
                this.issue_data[0].severity = 'Low'; 
            }
            if(this.issue_data[0].incident_type === 'Help Needed' || this.issue_data[0].incident_type === 'Others')
            {
                this.issue_data[0].severity = 'Normal'; 
            }
            if(this.issue_data[0].incident_type === 'Report Application Crash' || this.issue_data[0].incident_type === 'Wrong Data')
            {
                this.issue_data[0].severity = 'High'; 
            }

            this.issue_data[0]['description']= document.getElementById("text_area").value;



            var getURL = this.api_url + "/products/add_new_issue/" + this.$org_id.label;
     
            this.$http
            .post(getURL,this.issue_data)
            .then((response) => {
                let result = response.data;
                console.log(response.data);
                
                this.time_stamp = result.datetime_of_create;
               // this.user_id = data.user_id;
               // this.time_stamp = data.datetime_of_create;

               
               
                this.send_email();
               
                
               
            })
            .catch((err) => {
                this.$q.notify({
                message: err,
                color: "negative",
                });
                this.isLoading = false;
                // console.log(err);
            });
            
        

        },

        send_email(){
            console.log("send_mail");

            var getURL = this.api_url + "/products/trigger_mail/"+this.time_stamp;
     
            this.$http
            .post(getURL)
            .then((response) => {
                let result = response.data;
               
                this.file_name = result;

                console.log(result);

                this.$q.loading.hide();
                this.$alert('You will receive a mail shortly, please save the incident no for future use','Query Submitted successfully!');
                this.upload_to_s3();

                

               
            })
            .catch((err) => {
                this.$q.notify({
                message: err,
                color: "negative",
                });
                this.isLoading = false;
                // console.log(err);
            });



        },
        async upload_to_s3(){

          console.log(this.img_set);



            if(this.img_set === true)
            {
              const fileInput = document.querySelector("#fileInput");

              const file = fileInput.files[0];
              console.log(file)
              // get secure url from our server
              /*
              const  url  = await fetch("/s3Url").then(response => {
                console.log('Response:', response)
                return response.url;})
              */

              const url = await generateUploadURL(file["name"]);
              console.log("url");
              console.log(url);

              

              // post the image direclty to the s3 bucket
              await fetch(url, {
                method: "PUT",
                headers: {
                  "Content-Type": "multipart/form-data"
                },
                body: file
              }).then((response) =>
              {
                console.log("after upload",response);

                var img_url = "s3://help-and-support/dev-incident-files/"+file["name"];
                var row = {
                  url:img_url,
                  time:this.time_stamp

                }

                var postURL = this.api_url + `/products/update_img_url`;
                this.$http
                .post(postURL,[row])
                .then((response) => {
                  if (response.data == "true") {
                  
                    console.log("image updated successfully");
                  };
                });


              })

              

            }
            
             this.cancel_data();
             this.fetch_data();

        },
        cancel_data() {
          this.issue_data[0]['incident_type'] = 'Enquiry';
          this.img_set = false;
          document.getElementById("fileInput").value = null;
          this.issue_data[0]['description'] = '';
          document.getElementById("text_area").value = '';

    

        },
        fetch_data(){
          var getURL = this.api_url + "/products/show_all/" + this.$org_id.label;


     
            this.$http
            .post(getURL)
            .then((response) => {
                let result = response.data;

                console.log(result);
                
                let data = result.map((items) => {
                    return {
                    ...items,
                        
                    };
                });

                console.log("data");
                console.log(data);
                this.rows = data;

                

                

               
            })
            .catch((err) => {
                this.$q.notify({
                message: err,
                color: "negative",
                });
              
                // console.log(err);
            });

        },

        showAll() {
            this.show_all=true;
            this.show=false;
            this.show_btn=false;

            
        },

        Show() {
            this.show=true;
            this.show_all=false;
            this.show_btn=false;

            this.rows1[0]['incident_no']='';
            this.rows1[0]['subject']='';
            this.rows1[0]['description']='';
            this.rows1[0]['date_of_create']='';
            this.rows1[0]['present_status']='';
            this.rows1[0]['date_of_last_update']='';

            console.log(this.incident_no);

            for (let i = 0; i < this.rows.length; i++) {
                if(this.rows[i]['incident_id'] == this.incident_no){
                    console.log(i);
                    console.log(this.rows[i]['incident_id']);

                    this.rows1[0]['incident_no']=this.rows[i]['incident_id'];
                    this.rows1[0]['subject']=this.rows[i]['incident_type'];
                    this.rows1[0]['description']=this.rows[i]['description'];
                    this.rows1[0]['date_of_create']=this.rows[i]['datetime_of_create'];
                    this.rows1[0]['present_status']=this.rows[i]['status'];
                    this.rows1[0]['date_of_last_update']=this.rows[i]['datetime_of_last_update'];

                    console.log(this.rows1);

                }
            }

            if(this.rows1[0]['incident_no'] != this.incident_no)
            {
                this.$alert("The Incident number which you have entered is invalid, please check it and try again","Invalid Incident Number!")
            }

        }
    },

    created() {
        console.log("VUE_APP_ENV");
        console.log(process.env.VUE_APP_ENV)
        console.log("process.env.AWS_ACCESS_KEY_ID");
        
        console.log(process.env.VUE_APP_AWS_ACCESS_KEY_ID);

        var getURL = this.api_url + "/products/show_all/" + this.$org_id.label;


     
            this.$http
            .post(getURL)
            .then((response) => {
                let result = response.data;

                console.log(result);
                
                let data = result.map((items) => {
                    return {
                    ...items,
                        
                    };
                });

                console.log("data");
                console.log(data);
                this.rows = data;

                

                

               
            })
            .catch((err) => {
                this.$q.notify({
                message: err,
                color: "negative",
                });
                this.isLoading = false;
                // console.log(err);
            });


    }
}
</script>

<style>
   
   
    .container{
        width: 950px;
    
        
        margin: 50px auto 0px auto;
        padding:25px;

        background: #DDE6FB;
    }

    .head1{
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 28px;
        color: #0d70e9;

        
    }

    .myhead{
        background: rgba(183, 196, 206, 0.83);
        border-radius: 10px;
        padding: 10px 20px;
       margin-bottom: 25px;
       
    }

    .mybody{
        background: rgba(209, 217, 245, 0.76);
        border-radius: 10px;
        padding: 20px;
    }

    /*
    .lab{
    
    display:flex;
    flex-direction: column;
   
    padding:2px;
    }
    .lab label{
    font-size:1rem;
    padding:0.15rem;
    
    }
    .inp{
    
    display:flex;
    flex-direction: column;
   
    }
    */
    select, input{
   
    height:2.5rem;
    width: 97%;
    margin: 0px auto;
    background-color: white;
    padding:0 8px;
    
    border:0px solid blue;
    }

    input[type="file"] {
    background-color: rgba(209, 217, 245, 0.76);
    height:2.5rem;
    
  
    
    } 

    input[type="radio"] {
    background-color: rgba(209, 217, 245, 0.76); 
    height:1rem;   
    width: auto;
    margin: 10px;
    } 

    textarea{
    border:0px solid blue;
    width: 97%;
    padding: 8px;
        
    }
    
    label{
    font-size:1rem;
    font-weight: 500;
    }

    .align{
        display: flex;
        align-items: center;
        justify-content: left;
        
    }
</style>